
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"15","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.51 4.83L8.745.227a1.333 1.333 0 00-1.488 0L.489 4.83A1.11 1.11 0 000 5.748v8.136C0 14.499.51 15 1.136 15h13.728c.627 0 1.136-.5 1.136-1.116V5.748c0-.367-.183-.71-.49-.918zM7.763.945a.427.427 0 01.476 0l6.45 4.388-6.482 4.41a.367.367 0 01-.412 0l-6.482-4.41L7.762.945zm7.102 13.182H1.136a.245.245 0 01-.247-.243V6.108l6.399 4.352c.213.146.462.218.712.218.25 0 .5-.072.712-.217l6.4-4.353v7.776c0 .134-.112.242-.248.242z","fill":"#6C6C6C"}})])
          )
        }
      }
    